import { useHistory, useLocation } from 'react-router';
import useLocale from '@/hooks/useLocale';
import type { UseIsPageRouteResult, UseIsPageRouteRoutesBase } from './useIsPageRoute.types';

/**
 * Exposes `history`, locale `routes`, and `isHome` (`pathname === routes.home`).
 *
 * Pass `TRoutes` extending `{ home: string }` when callers need additional typed route keys (e.g. `gatorProtect`).
 * Must run under a `Router` and `LocaleProvider`.
 */
export function useIsPageRoute<
  T extends UseIsPageRouteRoutesBase = UseIsPageRouteRoutesBase,
>(): UseIsPageRouteResult<T> {
  const history = useHistory();
  const { pathname } = useLocation();
  const { routes } = useLocale() as { routes: T };
  const isHome = pathname === routes.home;
  const isInvoicesPage = pathname.includes(routes.invoices);

  return {
    isHome,
    history,
    routes,
    isInvoicesPage,
  };
}
